import axios from 'axios';
import {BASE_URL} from 'appConstants';
import {get, post, getDefaultConfig, getDefaultConfigWithToken} from 'sdk';

export const requestLogin = ({email, password, recaptcha}) => {
  const url = `${BASE_URL}/v1/authentication/admin/login/`;
  const data = {
    email,
    password,
    recaptcha
  };
  const params = {_transform: true};
  const headers = {...getDefaultConfig(), withCredentials: true};

  return axios.post(url, data, {params, ...headers});
};

export const requestLogout = () => {
  const url = `${BASE_URL}/v1/authentication/admin/logout/`;
  const params = {_transform: true};
  const headers = {...getDefaultConfigWithToken(), withCredentials: true};

  return axios.post(url, {}, {params, ...headers});
};

export const fetchMe = () => {
  const url = `${BASE_URL}/v1/authentication/admin/me/`;
  return get(url);
};

export const fetchUserByInvitationKey = ({key}) => {
  const url = `${BASE_URL}/v1/users/get-user-email-by-token/${key}/`;
  return get(url);
};

export const acceptInvitationAndSetPassword = ({key, password}) => {
  const url = `${BASE_URL}/v1/users/invitation-accept-and-set-password/`;
  return post(url, {token: key, password: password});
};

export const adminForgotPassword = ({email}) => {
  const url = `${BASE_URL}/v1/authentication/admin/forgotten-password/`;
  return post(url, {admin: email});
};

export const adminForgotPasswordSet = ({token, password}) => {
  const url = `${BASE_URL}/v1/authentication/admin/set-password/`;
  return post(url, {token, password});
};
